import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ButtonComp } from "../../../ui/input/Button";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { LetterSelectInput } from "./LetterSelectInput";
import { FULL_HUNGER } from "../../../tiles";
import { Actor } from "../../actors/Actor";
import { TextButton } from "../../../ui/input/TextButton";

export const TrashLetterSelect: ComponentF<{
  actor: Actor;
  onResult: (result: { letters: string[] }) => void;
  onCancel: () => void;
}> = (C, props) => {
  const max = 3; //TODO Pull this from the actor
  const [state, setState] = C.useState({ letters: [] });

  floodFill(C.display, C.bounds, Colors.OFF_BLACK);

  return [
    createElement(
      TextType,
      { x: 1, y: 0, w: C.bounds.w - 2, h: 1 },
      {
        title: "Trash Letters",
        align: ALIGN_TYPE.center,
      }
    ),
    createElement(
      TextType,
      { x: 1, y: 2, w: C.bounds.w - 2, h: 1 },
      {
        title: `Trash up to ${max} titles to gain some back`,
        align: ALIGN_TYPE.center,
      }
    ),
    createElement(
      TextType,
      { x: 1, y: 5, w: C.bounds.w - 2, h: 1 },
      { title: `-${FULL_HUNGER}`, align: ALIGN_TYPE.center }
    ),
    createElement(
      LetterSelectInput,
      { x: 0, y: Math.floor(C.bounds.h / 2), w: C.bounds.w, h: 3 },
      {
        letters: state.letters,
        spellWand: props.actor.spellWand,
        onUpdateLetters: (letters: any) => setState({ letters }),
        max,
        upperCase: props.actor.breed.isCapital,
      }
    ),
    createElement(
      TextButton,
      { x: C.bounds.w - 13, y: C.bounds.h - 1, w: C.bounds.w - 1, h: 1 },
      {
        title: "Confirm",
        keyLabel: "Enter",
        keys: ["Enter"],
        disabled: !state.letters.length,
        onClick: () => {
          if (state.letters.length) {
            closeModal();
            props.onResult({ letters: state.letters });
          }
        },
      }
    ),
    createElement(
      TextButton,
      { x: 0, y: C.bounds.h - 1, w: 10, h: 1 },
      {
        title: "Cancel",
        keyLabel: "Esc",
        keys: ["Escape"],
        onClick: () => {
          closeModal();
          props.onCancel();
        },
      }
    ),
  ];
};
